import { render, staticRenderFns } from "./CartRecovery.vue?vue&type=template&id=881821e6&scoped=true"
import script from "./CartRecovery.vue?vue&type=script&lang=js"
export * from "./CartRecovery.vue?vue&type=script&lang=js"
import style0 from "./CartRecovery.vue?vue&type=style&index=0&id=881821e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881821e6",
  null
  
)

export default component.exports